const delay = (timeout: number): Promise<any> =>
  new Promise((resolve) => setTimeout(resolve, timeout));

export default delay;
